<!-- <pre>{{ userRole | json }}</pre>  -->
<iot-show-user-inofs-in-user-role-manager
  [userId]="userRole.userId"
></iot-show-user-inofs-in-user-role-manager>
Role: {{ userRole.roleKey }}
